import ApplicationController from './application_controller'

export default class extends ApplicationController {
  connect() {
    super.connect()

    document.body.classList.toggle('sidebar-collapsed', localStorage.menuState === 'collapsed')

    window.addEventListener('turbo:before-cache', this._closeBeforeCache)
  }

  disconnect() {
    window.removeEventListener('turbo:before-cache', this._closeBeforeCache)
    super.disconnect()
  }

  // Mobile off-canvas overlay: CSS below the sm breakpoint reacts to
  // data-sidebar-open on the layout container.
  open() {
    this.element.setAttribute('data-sidebar-open', true)
  }

  close() {
    this.element.setAttribute('data-sidebar-open', false)
  }

  // Desktop: swap between the full and collapsed sidebar variants.
  expand() {
    document.body.classList.remove('sidebar-collapsed')
    localStorage.menuState = 'full'
  }

  collapse() {
    document.body.classList.add('sidebar-collapsed')
    localStorage.menuState = 'collapsed'
  }

  // Cached pages must never restore with the overlay open
  _closeBeforeCache = () => {
    this.element.setAttribute('data-sidebar-open', false)
  }
}
